import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import { GET_ALL_PROPERTY_LIST, GET_SERIVICE_TICKETS, UPDATE_PROPERTY_ITEM } from "../../../../Urls";

const initialState = {
  properties: {
    data: [],
    loader: false,
    updateLoader: false,
    caseLoader: false,
    caseData: []
  },
};

export const getServiceTicketsByServiceAccountId = createAsyncThunk(
  "app/propertiesSlice/getServiceTicket",
  async (crmServiceAccountId) => {
    const response = await axios.post(GET_SERIVICE_TICKETS, { crm_service_account_id: [crmServiceAccountId] });
    return response;
  }
);

export const getProperties = createAsyncThunk(
  "app/propertiesSlice/getProperties",
  async (user_id) => {
    const response = await axios.get(GET_ALL_PROPERTY_LIST + user_id);
    return response;
  }
);

export const updateProperties = createAsyncThunk(
  "app/propertiesSlice/updateProperties",
  async ({ user_id, item }) => {
    const response = await axios.put(UPDATE_PROPERTY_ITEM + user_id, item);
    return response;
  }
);


export const propertiesSlice = createSlice({
  name: "app/propertiesSlice",
  initialState,
  reducers: {

  },

  extraReducers: (builder) => {
    builder
      .addCase(getProperties.pending, (state) => {
        state.properties.loader = true;
      })
      .addCase(getProperties.fulfilled, (state, action) => {
        state.properties.loader = false;
        state.properties.data = action?.payload?.data?.data;
      })
      .addCase(getProperties.rejected, (state) => {
        state.properties.loader = false;
      })
      .addCase(updateProperties.pending, (state) => {
        state.properties.updateLoader = true;
      })
      .addCase(updateProperties.fulfilled, (state, action) => {
        state.properties.updateLoader = false;
        state.properties.data = action?.payload?.data?.data;
      })
      .addCase(updateProperties.rejected, (state) => {
        state.properties.updateLoader = false;
      })
      .addCase(getServiceTicketsByServiceAccountId.pending, (state) => {
        state.properties.caseLoader = true;
      })
      .addCase(getServiceTicketsByServiceAccountId.fulfilled, (state, action) => {
        state.properties.caseLoader = false;
        state.properties.caseData = action?.payload?.data?.data;
      })
      .addCase(getServiceTicketsByServiceAccountId.rejected, (state) => {
        state.properties.caseLoader = false;
      })
  },
});

export default propertiesSlice.reducer;
